module.exports = __webpack_public_path__ + "static/media/flood.fcd04e1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/flood.svg
// module id = 334
// module chunks = 0